export default "__VITE_ASSET__Dyuciaif__"